import { Component, OnInit, inject } from '@angular/core';
import { PwaService } from './shared/services/pwa.service';
import { TemaService } from './shared/services/tema.service';
import { ModulosUsuarioService } from './shared/services/modulos-usuario.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'Maja Sportswear';

  private readonly pwa = inject(PwaService);
  private readonly tema = inject(TemaService);
  private readonly modulosUsuario = inject(ModulosUsuarioService);

  ngOnInit(): void {
    this.pwa.iniciar();
  }
}
